module.exports = __webpack_public_path__ + "static/media/trash.5a226e36.svg";